// import { ResponseCookie } from "next/dist/compiled/@edge-runtime/cookies"
import type { CookieSerializeOptions } from 'cookie';

// CookieSerializeOptions
export const NEXT_AUTH_BASEPATH = '/dashboard/api/auth'
export const NEXT_AUTH_SALESFORCE_CALLBACK = `${NEXT_AUTH_BASEPATH}/callback/salesforce`
export const SECURE_COOKIE_OPTIONS: Partial<CookieSerializeOptions> = {
  secure: true,
  httpOnly: true,
  path: '/',
  sameSite: 'lax',
}
export const TOKEN_SCOPE = 'refresh_token web openid id pardot_api full'
export const MAX_HTTP_TIMEOUT = 10000

/* 
  Deleting cookies via  Vercel's current cookie api does not work.
  https://github.com/vercel/next.js/issues/40146
  
  These options are workaround to set a cookie with same name, 0 
  lifetime duration and expiration date in past. Browser will 
  automatically cleanup this cookie on arrival.
  
  This can be removed once nextjs provide a stable cookie api.
*/
export const REMOVE_SECURE_COOKIE: Partial<CookieSerializeOptions> = {
  httpOnly: true,
  maxAge: 0,
  sameSite: 'lax',
  secure: true,
  path: '/',
  expires: new Date(0)
}